export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // ------ V2 -----
      //
      {
        _name: 'CSidebarNavTitle',
        _children: ['v2-Quét online']
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Dữ liệu',
        to: '/v2/online_scan',
        icon: 'cil-layers',
        permission: 'scan_view'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Nhập liệu',
        to: '/v2/online_scan/new',
        icon: 'cil-layers',
        permission: 'scan_input'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Thống kê',
        to: '/v2/online_scan/analytics',
        icon: 'cil-layers',
        permission: 'scan_analytics'
      },
      // -----
      {
        _name: 'CSidebarNavTitle',
        _children: ['v2-Ký gửi']
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Dữ liệu',
        to: '/v2/products',
        icon: 'cil-layers',
        permission: 'product_view'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Nhập liệu',
        to: '/v2/products/new',
        icon: 'cil-layers',
        permission: 'product_input'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Thống kê',
        to: '/v2/products/analytics',
        icon: 'cil-layers',
        permission: 'product_analytics'
      },

      {
        _name: 'CSidebarNavTitle',
        _children: ['Bán hàng']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tin đăng',
        to: '/marketing/posts',
        icon: 'cil-star',
        permission: 'product_posting_view'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tin đăng v2',
        to: '/v2/posts',
        icon: 'cil-star',
        permission: 'product_posting_view'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Thống kê KH liên hệ',
        to: '/sales/customers',
        icon: 'cil-star',
        permission: 'product_posting_analytics'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Thống kê tin đăng v2',
        to: '/v2/posts/analytics',
        icon: 'cil-star',
        permission: 'product_posting_analytics'
      },

      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Khách hàng']
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Dữ liệu',
        to: '/database/customers',
        icon: 'cil-star',
        permission: 'client_view'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Tìm kiếm',
        to: '/database/customers/find',
        icon: 'cil-star',
        permission: 'client_view'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Thống kê',
        to: '/database/customers/analytics',
        icon: 'cil-star',
        permission: 'client_analytics'
      },
      { 
        _name: 'CSidebarNavItem',
        name: 'Chăm sóc khách hàng',
        to: '/database/customers/care',
        icon: 'cil-star',
        permission: 'client_view'
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Công cụ khác']
      },

      { 
        _name: 'CSidebarNavItem',
        name: 'Bản đồ',
        to: '/map/land',
        icon: 'cil-layers',
        permission: 'map_view'
      },

      // { 
      //   _name: 'CSidebarNavItem',
      //   name: 'Mã tên đường',
      //   to: '/others/street_code',
      //   icon: 'cil-layers'
      // },

      // { 
      //   _name: 'CSidebarNavItem',
      //   name: 'Tài chính',
      //   to: '/others/finance',
      //   icon: 'cil-layers'
      // },

      { 
        _name: 'CSidebarNavItem',
        name: 'Định giá',
        to: '/v2/validation',
        icon: 'cil-layers',
        permission: 'tool_validation'
      },

      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Khách hàng v2']
      },

      { 
        _name: 'CSidebarNavItem',
        name: 'Dữ liệu',
        to: '/v2/clients',
        icon: 'cil-layers',
        permission: 'client_view'
      },

      { 
        _name: 'CSidebarNavItem',
        name: 'Nhập liệu',
        to: '/v2/clients/new',
        icon: 'cil-layers',
        permission: 'client_edit'
      },

    ]
  }
]